import activeIcon from '../assets/icons/activeRecruits.svg';
import inActiveIcon from '../assets/icons/inActiveRecruits.svg';
import React from 'react';

interface RecruitersStatus {
	isActive: boolean;
	count: number;
}
const RecruitersStatus: React.FC<RecruitersStatus> = ({ isActive, count }) => {
	const countStyle = {
		color: isActive ? 'var(--lime)' : 'var(--error)',
	};
	return (
		<div className="p-5 flex flex-col justify-between h-full">
			<div className="font-semibold">
				{isActive ? 'Active Recruits' : 'InActive Recruits'}
			</div>
			<div className="flex justify-between w-full">
				<img src={isActive ? activeIcon : inActiveIcon}></img>
				<span style={countStyle} className="text-3xl font-medium">
					{count}
				</span>
			</div>
		</div>
	);
};

export default RecruitersStatus;
